import styled from "styled-components";
import { WrapperContainer } from "../../../../../components";
import { FormButton } from "../../styled";

export const DeleteUserConfirmationWrapper = styled(WrapperContainer)`
  b {
    overflow-wrap: anywhere;
  }
`;

export const ButtonsWrapper = styled(WrapperContainer)`
  ${FormButton} {
    height: 40px;
    padding: 0 24px;

    min-width: unset;
    white-space: nowrap;
  }
`;
